import { fetchAuthSession } from 'aws-amplify/auth';
import { isCognitoConfigured } from './amplify';

/**
 * Get the current Cognito ID token string for API calls.
 * Returns null if Cognito is not configured or session is unavailable.
 */
export async function getIdToken() {
  if (!isCognitoConfigured) return null;
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}
